import { ColorEnum } from "./ColorEnums";

export enum CurrencyEnum {
    MYR = 'MYR',
    PHP = 'PHP',
    SGD = 'SGD',
    IDR = 'IDR',
    BND = 'BND',
    THB = 'THB',
}

